import tabController from './tabController.js';

export default (tab) => {
    tabController?.[tab]();
};
